import { Link, useLocation } from '@/libs/router'
import { useIntlayer } from 'react-intlayer'
import { tv } from '@/libs/tv'
import { usePermission } from '@/features/permissions/hooks/use-permission'

const navLink = tv({
	base: 'text-606060 text-sm',
	variants: {
		active: {
			true: 'text-primary font-medium underline underline-offset-8',
		},
	},
})

type NavItem = {
	path: string
	label: string
}

const SettingsNav = () => {
	const content = useIntlayer('settings-nav')
	const location = useLocation()
	const canManagePermissions = usePermission('settings.permissions.manage')

	const items: NavItem[] = [
		{ path: '/settings/members', label: content.members.value },
		...(canManagePermissions ? [{ path: '/settings/teams', label: content.teams.value }] : []),
		...(canManagePermissions ? [{ path: '/settings/permissions', label: content.permissions.value }] : []),
	]

	return (
		<nav className='py-4'>
			<ul className='flex space-x-6 text-sm overflow-auto'>
				{items.map(item => (
					<li key={item.path}>
						<Link to={item.path} className={navLink({ active: location.pathname === item.path })}>
							{item.label}
						</Link>
					</li>
				))}
			</ul>
		</nav>
	)
}

export { SettingsNav }
